/* eslint-disable */
// Configuration that works with both Gen1 and Gen2 formats

// Try to import amplify_outputs.json first (Gen2 format)

import outputs from '../amplify_outputs.json';

let amplifyConfig = {
    aws_project_region: outputs.auth?.aws_region || 'eu-central-1',
    aws_cognito_identity_pool_id: outputs.auth?.identity_pool_id || '',
    aws_cognito_region: outputs.auth?.aws_region || 'eu-central-1',
    aws_user_pools_id: outputs.auth?.user_pool_id || '',
    aws_user_pools_web_client_id: outputs.auth?.user_pool_client_id || '',
    oauth: {},
    aws_cognito_username_attributes: outputs.auth?.username_attributes || [],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: outputs.auth?.standard_required_attributes || ['EMAIL'],
    aws_cognito_mfa_configuration: 'OFF',
    aws_cognito_mfa_types: ['SMS'],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: []
    },
    aws_cognito_verification_mechanisms: ['EMAIL'],
    aws_cognito_authentication_flow_type: 'USER_PASSWORD_AUTH',

    // Storage configuration
    aws_user_files_s3_bucket: outputs.storage?.bucket_name || '',
    aws_user_files_s3_bucket_region: outputs.storage?.aws_region || 'eu-central-1',

    // GraphQL API configuration
    aws_appsync_graphqlEndpoint: outputs.data?.url || '',
    aws_appsync_region: outputs.data?.aws_region || 'eu-central-1',
    aws_appsync_authenticationType: outputs.data?.default_authorization_type || 'API_KEY',
    aws_appsync_apiKey: outputs.data?.api_key || '',

    // REST API configuration
    API: {
      endpoints: []
    }
};

// Add REST API endpoints if they exist in custom outputs
const normalizeEndpoint = (url) => url.replace(/\/+$/, '');
if (outputs.custom && outputs.custom.API) {
    const restApis = outputs.custom.API;
    amplifyConfig.API.endpoints = Object.keys(restApis).map(apiName => ({
      name: apiName,
      endpoint: normalizeEndpoint(restApis[apiName].endpoint),
      region: restApis[apiName].region
    }));
}

console.log('AppSync GraphQL Endpoint: ' + amplifyConfig.aws_appsync_graphqlEndpoint)
console.log('Auth Flow Type: ' + amplifyConfig.aws_cognito_authentication_flow_type)

// Force USER_PASSWORD_AUTH - must be set after all config to ensure it's not overridden
amplifyConfig.authenticationFlowType = 'USER_PASSWORD_AUTH';

export default amplifyConfig;
